import axios from "./axios"
import urls from "./urls"

export const addToCartV2 = (productId, centres) => {
  // If this breaks then let it break. Because this should never happen
  const centreId = centres.find(centre => centre.is_default).centre_id

  if (!centreId) {
    throw new Error("No default centre found")
  }
  return axios.post(urls.cart.addItem, {
    product_id: productId,
    centre_id: centreId
  })
}
